import { ComboBox, Panel, TextField } from "@fluentui/react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { useCallback } from "react";
import { PanelHeader } from "../../../../../components/Panel/PanelHeader";
import { usePanelTurnoInsertar } from "./usePanelTurnoInsertar";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { ProgressBarLoading } from "../../../../../components/ProgressBarLoading/ProgressBarLoading";
import { MessageBarResponse } from "../../../../../components/MessageBarResponse/MessageBarResponse";
import { json } from "d3";
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic";

export interface IPanelTurnoInsertar extends IOpenPanel{
}


export const PanelTurnoInsertar=(props:IPanelTurnoInsertar)=>{
    const {request,setRequest,postInsertarTurno,loading,disableForm,reset,mensaje,status} = usePanelTurnoInsertar(props)
    const onRenderHeader = useCallback(
        () => (
          <PanelHeaderBasic
          subTextHeader=""
          textHeader="Agregar Turno"
        />
        ),
        []
      );
      const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={postInsertarTurno}
              onDismiss={reset}
            />
          </>
        ),
        [disableForm,request]
      );
   

   return (
    <Panel
    isOpen={props.isOpen}
    onDismiss={reset}
    onRenderFooter={onRenderFooter}
    isFooterAtBottom
    onRenderHeader={onRenderHeader}
    >
    <div hidden={mensaje == ""}>
        <MessageBarResponse
          objetoResponse={{ codigo: status, mensaje: mensaje }}
          close={true}
        />
      </div>
    <div hidden={!loading}>
        <ProgressBarLoading></ProgressBarLoading>
    </div>

    <div hidden={loading}>
    {!mensaje && (
        <>
         <TextField 
         type="text"
         label="Nombre de Turno"
         placeholder="Ingrese Nombre"
         autoComplete="off"
         value={request.nombre}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombre:newValue})}
         }}
         />
         <TextField 
         type="text"
         label="Codigo de Turno"
         placeholder="Ingrese Codigo"
         autoComplete="off"
         value={request.codigo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,codigo:newValue})}
         }}
         />
         <TextField 
         type="time"
         label="Hora Inicio"
         placeholder="Ingrese Hora Inicio"
         autoComplete="off"
         value={request.horaInicio}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,horaInicio:newValue})}
         }}
         />
         <TextField 
         type="time"
         label="Hora Fin"
         placeholder="Ingrese Hora Fin"
         autoComplete="off"
         value={request.horaFin}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,horaFin:newValue})}
         }}
         />
         </>)}
        </div>
         
    </Panel>
   )
}